import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 12L1.376 9c-.684-.547-.384-1.647.484-1.771L7 7l2.195-5.503a.9.9 0 0 1 1.61 0L13 7l5.14.229c.868.124 1.168 1.224.484 1.771L15 12l.989 5.857a1 1 0 0 1-1.437 1.036L10 16l-4.552 2.892a1 1 0 0 1-1.437-1.036L5 12z"
});

var SvgFavoriteMajor = function SvgFavoriteMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgFavoriteMajor as S };
